export function DotsGridIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      className="al-trigger-icon"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="4" height="4" rx="2" fill="currentColor" />
      <rect x="7" width="4" height="4" rx="2" fill="currentColor" />
      <rect x="14" width="4" height="4" rx="2" fill="currentColor" />
      <rect y="7" width="4" height="4" rx="2" fill="currentColor" />
      <rect x="7" y="7" width="4" height="4" rx="2" fill="currentColor" />
      <rect x="14" y="7" width="4" height="4" rx="2" fill="currentColor" />
      <rect y="14" width="4" height="4" rx="2" fill="currentColor" />
      <rect x="7" y="14" width="4" height="4" rx="2" fill="currentColor" />
      <rect x="14" y="14" width="4" height="4" rx="2" fill="currentColor" />
    </svg>
  );
}

export function BackArrowIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 19L5 12M5 12L12 5M5 12H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
